(function () {
	const REF = window.meloRef || "melo";
	const PROMO_LABEL = window.meloPromoLabel || "melo-podcast";
	const DISCOUNT_CODE = (window.meloDiscountCode || "").toUpperCase();
	const BADGE_TEXT = window.meloBadgeText || "15% OFF";
	const DISCOUNT_PCT = window.meloDiscount || 15;
	const CHECK_TYPE = window.meloCheckType || "products";
	const TARGET_HANDLES = window.meloTargetHandles || [];
	const TARGET_COLLECTIONS = window.meloTargetCollections || [];
	const PRODUCT_COLLECTIONS = window.meloProductCollections || [];

	function isTargetProduct() {
		if (CHECK_TYPE === "products") {
			return TARGET_HANDLES.length === 0 || TARGET_HANDLES.includes(window.meloProductHandle);
		}
		return TARGET_COLLECTIONS.length === 0 || TARGET_COLLECTIONS.some(h => PRODUCT_COLLECTIONS.includes(h));
	}

	const cartUpdateUrl = window.routes ? window.routes.cart_update_url : "/cart/update.js";
	const hasRef = window.location.search.includes("ref=" + REF);

	console.log("[melo] page load", {
		url: window.location.href,
		hasRef,
		isTarget: isTargetProduct(),
		productHandle: window.meloProductHandle,
	});

	// ── No ref present ──────────────────────────────────────────────────────────
	if (!hasRef) {
		if (!DISCOUNT_CODE || !isTargetProduct()) return;

		fetch("/cart.js").then(r => r.json()).then(cart => {
			console.log("[melo] cart on load (no ref):", {
				discount_codes: cart.discount_codes,
				total_discount: cart.total_discount,
				attributes: cart.attributes,
			});

			const hasMeloDiscount = cart.discount_codes.some(
				d => d.code.toUpperCase() === DISCOUNT_CODE,
			);

			if (!hasMeloDiscount) {
				console.log("[melo] no MELO discount in cart — nothing to clean");
				return;
			}

			// Remove only the melo discount, preserve any others
			const remaining = cart.discount_codes
				.filter(d => d.code.toUpperCase() !== DISCOUNT_CODE)
				.map(d => d.code)
				.join(",");

			console.log("[melo] removing MELO discount, remaining codes:", remaining || "(none)");
			fetch(cartUpdateUrl, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
					discount: remaining,
					attributes: { [PROMO_LABEL]: "" },
				}),
			})
				.then(r => r.json())
				.then(cart => console.log("[melo] cart after cleanup:", {
					discount_codes: cart.discount_codes,
					attributes: cart.attributes,
				}))
				.catch(err => console.warn("[melo] cart update error:", err));
		}).catch(err => console.warn("[melo] cart.js fetch error:", err));

		return;
	}

	// ── Ref present ─────────────────────────────────────────────────────────────
	if (!isTargetProduct()) {
		console.log("[melo] ref present but not a target product — exiting");
		return;
	}

	function activatePromo() {
		console.log("[melo] PROMO ACTIVE");

		function setupUI() {
			// 1. Inject hidden line item property into every product form on the page
			document.querySelectorAll("product-form form").forEach(form => {
				const input = document.createElement("input");
				input.type = "hidden";
				input.name = "properties[_melo_source]";
				input.value = PROMO_LABEL;
				form.appendChild(input);
			});

			// 2. Auto-select one-time purchase option on load and after every variant change
			//    forceOtp is called via rAF so variant-picker.js line 214 (sub.checked=true) runs first
			function forceOtp() {
				const otpRadio = document.querySelector("#purchase-otp");
				if (otpRadio && !otpRadio.checked) {
					otpRadio.checked = true;
					otpRadio.dispatchEvent(new Event("change", { bubbles: true }));
				}
				syncVisibility();
			}
			requestAnimationFrame(forceOtp);

			// 3. Reverse purchase option order (OTP first, sub second)
			document.querySelector(".purchase-options")?.classList.add("purchase-options--melo");

			// 4. Show discount badge above the main product price
			//    Only visible when one-time purchase (#purchase-otp) is selected
			const priceContainer = document.querySelector("price-component:has(p.product-price)");
			let badge = null;
			if (priceContainer) {
				badge = document.createElement("span");
				badge.className = "melo-promo-badge";
				badge.setAttribute("aria-label", BADGE_TEXT);
				badge.textContent = BADGE_TEXT;
				const priceP = priceContainer.querySelector("p[data-price]");
				priceContainer.insertBefore(badge, priceP);
				priceContainer.classList.add("price-component--melo");
			}

			// 5. Tooltip inline inside p.product-price
			const priceEl = document.querySelector("price-component p[data-price]");
			let tooltip = null;
			if (priceEl) {
				const tooltipText = window.meloTooltipText || "15% off applied at checkout";
				tooltip = document.createElement("span");
				tooltip.className = "melo-tooltip-wrapper";
				tooltip.style.display = "none";
				tooltip.innerHTML =
					'<svg width="16" height="16" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M11.661 17.5V9.292H13.837V17.5H11.661ZM11.661 8.012V6.06H13.837V8.012H11.661Z" fill="currentColor"/><circle cx="12.957" cy="12" r="11" stroke="currentColor" stroke-width="2"/></svg>' +
					'<span class="melo-tooltip-text" role="tooltip">' + tooltipText + "</span>";
				priceEl.appendChild(tooltip);
			}

			// 6. Promo price: show discounted price as main price, original as compare-at
			//    Targets all price-component[data-type="one-time"] — covers both the top-level
			//    price display and the price inside the .otp-block subscription widget.
			function parsePrice(html) {
				return parseFloat(html.replace(/<[^>]+>/g, "").replace(/[^0-9.]/g, "")) || 0;
			}

			function formatLike(amount, tmpl) {
				return tmpl.replace(/[\d,]+\.\d{2}/, amount.toFixed(2));
			}

			function applyPromoPrice(originalHtml) {
				document.querySelectorAll('price-component[data-type="one-time"], price-component:has(p.product-price)').forEach(container => {
					const priceSpan = container.querySelector("p[data-price] span");
					const compareEl = container.querySelector("p[data-compare-at-price]");
					if (!priceSpan) return;
					const src = originalHtml || priceSpan.innerHTML;
					const original = parsePrice(src);
					if (!original) return;
					const discounted = original * (1 - DISCOUNT_PCT / 100);
					priceSpan.innerHTML = formatLike(discounted, src);
					if (compareEl) {
						compareEl.innerHTML = src;
						compareEl.classList.remove("hidden");
					}
				});
			}

			// Sync badge + tooltip visibility based on purchase type (OTP vs subscription)
			function syncVisibility() {
				const otpRadio = document.querySelector("#purchase-otp");
				const isOtp = !otpRadio || otpRadio.checked;
				if (badge) badge.style.display = isOtp ? "" : "none";
				if (tooltip) tooltip.style.display = isOtp ? "" : "none";
			}

			// Radio change events (user manually switches OTP ↔ sub)
			document.querySelectorAll('input[name="purchase_type"]').forEach(input =>
				input.addEventListener("change", syncVisibility),
			);

			// Variant change: listen to the same inputs variant-picker.js uses.
			// Its onVariantChange handler runs first (registered in constructor) and sets
			// #purchase-sub.checked = true — our rAF fires after and forces OTP back.
			document.querySelectorAll(".option-input, .special-product-input, .special-product-input-2").forEach(input =>
				input.addEventListener("change", () => requestAnimationFrame(forceOtp)),
			);

			// price:changed: apply discounted price for OTP, re-sync badge/tooltip visibility
			document.addEventListener("price:changed", (e) => {
				requestAnimationFrame(() => {
					// price-component has already updated spans from e.detail.price by this rAF
					if (e.detail.type === "one-time") applyPromoPrice(e.detail.price);
					syncVisibility();
				});
			});

			// Initial apply — covers products with no subscription option (no price:changed fires on load)
			requestAnimationFrame(applyPromoPrice);

			syncVisibility();

			// 5. Stamp cart attribute immediately for order tagging via Shopify Flow
			fetch(cartUpdateUrl, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ attributes: { [PROMO_LABEL]: "true" } }),
			});
		}

		if (document.readyState === "loading") {
			document.addEventListener("DOMContentLoaded", setupUI);
		} else {
			setupUI();
		}
	}

	if (!DISCOUNT_CODE) {
		activatePromo();
		return;
	}

	// Check cart: apply discount if missing, then activate promo UI
	fetch("/cart.js").then(r => r.json()).then(cart => {
		const hasDiscount = cart.discount_codes.some(
			d => d.code.toUpperCase() === DISCOUNT_CODE,
		);
		console.log("[melo] ref visit — discount check:", { hasDiscount, discount_codes: cart.discount_codes });

		if (hasDiscount) {
			activatePromo();
		} else {
			// Discount not yet applied — apply it via cart/update.js, then activate
			console.log("[melo] applying discount via cart API");
			fetch(cartUpdateUrl, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ discount: DISCOUNT_CODE }),
			})
				.then(r => r.json())
				.then(cart => {
					console.log("[melo] discount applied:", cart.discount_codes);
					activatePromo();
				})
				.catch(err => {
					console.warn("[melo] failed to apply discount:", err);
					activatePromo(); // activate UI anyway
				});
		}
	}).catch(err => {
		console.warn("[melo] cart.js fetch error — activating promo anyway:", err);
		activatePromo();
	});
})();
